import { useEffect } from "react";
import io from "socket.io-client";
import { BASE_URL } from "@/constants/url";
import UploadCarForm from "./UploadCarForm";
const socket = io(BASE_URL, {}); // Replace with the actual server URL

const UploadCar = () => {
  useEffect(() => {
    // const socket = io(BASE_URL); // Replace with the actual server URL
    // setSocketConnection(socket);
    socket.connect();
    socket.on("connect", () => {
      console.log("client is connected :", socket.id); // x8WIv7-mJelg7on_ALbx
    });

    socket.on("disconnect", () => {
      console.log("client is disconnected :", socket.connected); // false
       socket.connect();
    });

     socket.on("reconnect", () => {
      console.log("reconnect to server");
    });

     socket.on('reconnect_attempt', () => {
      console.log('Attempting to reconnect to server');
    });

     socket.on('reconnect_error', (error) => {
      console.error('Reconnection attempt failed:', error.message);
     });
    
    socket.on("welcome", (data) => {
      console.log(data.message);
    });

    socket.on("disconnect", () => {
      console.log("disconncted from server");
      socket.connect();
    });

    // Cleanup: Disconnect socket when the component unmounts
    return () => {
      socket.disconnect();
    };
  }, []);

  return <UploadCarForm socket={socket} />;
};
export default UploadCar;
